import { i18n } from "@lingui/core"
import { t } from "@lingui/macro"
import { ValidateQuoteErrorResponse } from "@ssc-booking/api-contracts"
import { useEffect } from "react"
import { UseFormReturn, UseFormSetError } from "react-hook-form"
import { SwitchFlowSend } from "../../app-core/v3/_common/machines/switch-flow-machine"
import { isAllFieldsEmpty } from "../../app-core/_common/object"
import { WebQuoteFormData } from "./WebQuoteForm"

export const useUpdateFlowFormOnChange = (watch: UseFormReturn<WebQuoteFormData>["watch"], sendSF: SwitchFlowSend) => {
    useEffect(() => {
        const subscription = watch((value, { name }) => {
            if (isAllFieldsEmpty(value) || !name) return
            sendSF({ type: "UPDATE_WEB_QUOTE_FORM", data: value })
        })
        return () => subscription.unsubscribe()
    }, [watch, sendSF])
}

export const useSetErrors = (
    validationError: ValidateQuoteErrorResponse["errorCode"] | undefined,
    setError: UseFormSetError<WebQuoteFormData>,
) => {
    useEffect(() => {
        if (validationError === "invalidEmail") {
            setError("email", {
                type: "invalid",
                message: i18n._(t`form-invalid-email-address`),
            })
        }
    }, [setError, validationError])
}
